import { isNull, isUndefined } from 'lodash';
import api from '../../old/api/axios';

const dayjs = require('dayjs');

const encode = async (token: string, isCallServerToGetDate: boolean = true) => {
  if (isNull(token) || isUndefined(token)) {
    return null;
  } else {
    const { data } = isCallServerToGetDate
      ? await api.get('/date-server')
      : { data: { DataServidor: getFormattedDate() } };
    const currentDate = data?.DataServidor;
    const dateFormated = formatDate(currentDate);
    const base64 = encodeToBase64(dateFormated);
    const startPosition = getStartPosition(currentDate);
    const newToken = generetedNewToken(token, startPosition, base64);
    return newToken;
  }
};

const getFormattedDate = () => {
  const currentDate = new Date(Date.now());
  const formattedDate = currentDate.toISOString().split('.')[0]; // Removes milliseconds
  return formattedDate;
};

const encodeToBase64 = (text: string) => {
  return btoa(text);
};

const formatDate = (date: any) => {
  return dayjs(date).format('ssYYYYmmDDMMHH');
};

const generetedNewToken = (token: string, start: any, base64: any) => {
  var tokenChanged =
    token.substring(0, token.length - 10) +
    start +
    base64.length +
    token.substring(token.length - 10);

  var newToken = tokenChanged.substring(0, start);
  tokenChanged = tokenChanged.substring(start);
  var text = '';
  for (let index = 0; index < base64.length; index++) {
    text = tokenChanged.substring(0, 2);
    tokenChanged = tokenChanged.substring(2);
    newToken += base64.substring(index, index + 1) + text;
  }
  return newToken + tokenChanged;
};

const getStartPosition = (currentDate: any) => {
  return new Date(currentDate).getHours() % 2 !== 0 ? 30 : 50;
};

export default encode;
